//MyTeamCreate
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { GenerateThink5whysTeamCode } from '../../components/GenerateThink5whysCode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faMicrophoneSlash, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/Concerns.css';

const MyTeamCreate = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const userId = authState.user._id;

  const [fetchData, { loading }] = useFetch();
  const { teamId } = useParams();
  const mode = teamId === undefined ? "add" : "update";
  const [teamList, setTeamList] = useState(null);
  const [error, setError] = useState(null);
  const [autoTeamCode, setAutoTaskCode] = useState(GenerateThink5whysTeamCode());
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [errors, setErrors] = useState(null);

  const [formData, setFormData] = useState({
    createdBy: authState.user._id,
    creatorCode: authState.user.think5whyscode,
    creatorName: authState.user.name,
    teamType: 'FRI', 
    teamCode: autoTeamCode, 
    teamTitle: '',
    teamDesc: '',
    teamDos: '',
    teamDont: '',
    teamMicroPage: '',
    myTeamRemarks: '',
    dateCreated: new Date(),
    isActive: 1,
    isDeleted: 0,
    masterTeamCode: '',
    masterTeamTitle: '',
    masterTeamCreator: '',
    isLevel: false,
    entityCode: '',
    myTeamMembers: null,
  });

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/myteams/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token },
        data: {userId: userId, teamId: teamId} 
      };

      fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log("response for update",data);
        setTeamList(data.userTeam);
        // console.log("response for data.userTeam",data.userTeam);

        setFormData({
          createdBy: data.userTeam.createdBy,
          creatorCode: data.userTeam.creatorCode,
          creatorName: data.userTeam.creatorName,
          teamType: data.userTeam.teamType,
          teamCode: data.userTeam.teamCode,
          teamTitle: data.userTeam.teamTitle,
          teamDesc: data.userTeam.teamDesc,
          teamDos: data.userTeam.teamDos,
          teamDont: data.userTeam.teamDont,
          teamMicroPage: data.userTeam.teamMicroPage,
          myTeamRemarks: data.userTeam.myTeamRemarks,
          dateCreated: data.userTeam.dateCreated,
          isActive: data.userTeam.isActive,
          isDeleted: data.userTeam.isDeleted,
          masterTeamCode: data.userTeam.masterTeamCode,
          masterTeamTitle: data.userTeam.masterTeamTitle,
          masterTeamCreator: data.userTeam.masterTeamCreator,
          isLevel: data.userTeam.isLevel,
          entityCode: data.userTeam.entityCode,
          myTeamMembers: data.userTeam.myTeamMembers,
        });
      })
      .catch((error) => {
        console.error("Error fetching Team data:", error);
        setError("Error fetching Team data");
      });
    }
  }, [mode, authState, teamId, fetchData, setTeamList]);


  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      createdBy: userTeam.createdBy,
      creatorCode: userTeam.creatorCode,
      creatorName: userTeam.creatorName,
      teamType: userTeam.teamType,
      teamCode: userTeam.teamCode,
      teamTitle: userTeam.teamTitle,
      teamDesc: userTeam.teamDesc,
      teamDos: userTeam.teamDos,
      teamDont: userTeam.teamDont,
      teamMicroPage: userTeam.teamMicroPage,
      myTeamRemarks: userTeam.myTeamRemarks,
      dateCreated: userTeam.dateCreated,
      isActive: userTeam.isActive,
      isDeleted: userTeam.isDeleted,
      masterTeamCode: userTeam.masterTeamCode,
      masterTeamTitle: userTeam.masterTeamTitle,
      masterTeamCreator: userTeam.masterTeamCreator,
      isLevel: userTeam.isLevel,
      entityCode: userTeam.entityCode,
      myTeamMembers: userTeam.myTeamMembers,
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const errors = validateForm(formData);
    // console.log("error : ",errors," no. of error",Object.keys(errors).length);
    setFormErrors(errors);
    setCountFormErrors(Object.keys(errors).length);
    // console.log("setFormErrors : ",setFormErrors);

    if (Object.keys(errors).length > 0) {
      setFormErrors(
        Object.keys(errors).reduce((total, key) => {
          total[key] = errors[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = {
        url: "/myteams",
        method: 'post',
        data: formData,
        headers: { Authorization: authState.token },
      };
  
      // console.log('Creating team with config:', config);
      fetchData(config).then(() => {
        navigate("/myprofile-ownteams");
      });
    }
    else {
      const config = { 
        url: `/myteams/${teamId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" myteams ",config);

      fetchData(config).then(() => {
        navigate("/myprofile-ownteams");
      })
      .catch((error) => {
        console.error("Error updating Team:", error);
        setError("Error updating Team");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.teamType) {
      errors.teamType = "Please select a team type";
    }
    if (!formData.teamTitle) {
      errors.teamTitle = "Title is required";
    } else if (formData.teamTitle.length > 100) {
      errors.teamTitle = "Title cannot exceed 1000 characters";
    }
    if (!formData.teamDesc) {
      errors.teamDesc = "Description is required";
    } else if (formData.teamDesc.length > 500) {
      errors.teamDesc = "Description cannot exceed 500 characters";
    }
    // if (formData.masterTeamTitle.length > 100) {
    //   errors.masterTeamTitle = "Cannot exceed 100 characters";
    // }
    if (formData.masterTeamCode.length > 14) {
      errors.masterTeamCode = "Cannot exceed 14 characters";
    }
    if (formData.teamDont.length > 100) {
      errors.teamDont = "Cannot exceed 100 characters";
    }
    if (formData.teamDos.length > 1000) {
      errors.teamDos = "Cannot exceed 1000 characters";
    }
    if (formData.myTeamRemarks.length > 1000) {
      errors.myTeamRemarks = "Remarks cannot exceed 1000 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  return (
    <>
      <MainLayout>
        <div className='mt-12'>
          <h3 className='text-2xl font-bold text-white text-center'>Profile - Team / Groups Creation</h3>
            {loading ? (
              <Loader />
            ) : (
              <div className='text-sm'>
                <div className="mx-auto p-4">
                  <div className="text-center mb-2">
                    <h2 className="text-lg font-semibold text-yellow-200">
                      {mode === "add" ? "Add New RCA" : "Edit RCA"}
                    </h2>
                  </div>

                  <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <p className="text-yellow-300 text-sm">Team Code: {autoTeamCode}</p>
                  </div>
                </div>
               
                <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                    <div className="flex flex-col mt-1 text-sm">
                      <label>Team Type:</label>
                      <select className="text-black w-40" value={formData.teamType} onChange={(e) => setFormData({ ...formData, teamType: e.target.value })}>
                        <option value={"ACA"}>Academic</option>
                        <option value={"ADM"}>Administrative</option>
                        <option value={"BRA"}>Branch</option>
                        <option value={"CAM"}>Campaign</option>
                        <option value={"COM"}>Company Wide</option>
                        <option value={"SIT"}>Construction Site</option>
                        <option value={"DEP"}>Departmental</option>
                        <option value={"FAM"}>Family</option>
                        <option value={"FAC"}>Fact Finding</option>
                        <option value={"FRI"}>Friends</option>
                        <option value={"FUN"}>Fun</option>
                        <option value={"INS"}>Institutional</option>
                        <option value={"INV"}>Investigation</option>
                        <option value={"MAN"}>Management</option>
                        <option value={"MIN"}>Ministry</option>
                        <option value={"PRO"}>Professional</option>
                        <option value={"PRJ"}>Project</option>
                        <option value={"REG"}>Regional</option>
                        <option value={"WOR"}>Work</option>
                        <option value={"ZON"}>Zonal</option>
                      </select>
                      {fieldError("teamType")}
                    </div>
                    <div className="flex flex-col">
                      <label>Team Title</label>
                      <input
                        type="text"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                        }}
                        value={formData.teamTitle}
                        onChange={(e) => setFormData({ ...formData, teamTitle: e.target.value })}
                        placeholder="Enter team title"
                      />
                      {fieldError("teamTitle")}
                    </div>
                    <div className="flex flex-col">
                      <label>Team Description</label>
                      <textarea
                        className="profile-textarea"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                          maxHeight: '150px' 
                        }}
                        value={formData.teamDesc}
                        onChange={(e) => setFormData({ ...formData, teamDesc: e.target.value })}
                        placeholder="Enter team description"
                      />
                      {fieldError("teamDesc")}
                    </div>
                    <div className="flex flex-col">
                      <label>Team Do's</label>
                      <textarea
                        className="profile-textarea"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                          maxHeight: '150px' 
                        }}
                        value={formData.teamDos}
                        onChange={(e) => setFormData({ ...formData, teamDos: e.target.value })}
                        placeholder="Enter team do's"
                      />
                      {fieldError("teamDos")}
                    </div>
                    <div className="flex flex-col">
                      <label>Team Don'ts</label>
                      <textarea
                        className="profile-textarea"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                          maxHeight: '150px' 
                        }}
                        value={formData.teamDont}
                        onChange={(e) => setFormData({ ...formData, teamDont: e.target.value })}
                        placeholder="Enter team don'ts"
                      />
                      {fieldError("teamDont")}
                    </div>
                    <div className="flex flex-col">
                      <label>Micro Page Link</label>
                      <input
                        type="text"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                        }}
                        value={formData.teamMicroPage}
                        onChange={(e) => setFormData({ ...formData, teamMicroPage: e.target.value })}
                        placeholder="Enter micro page link"
                      />
                      {fieldError("teamMicroPage")}
                    </div>
                    <div className="flex flex-col">
                      <label>Team Remarks</label>
                      <textarea
                        className="profile-textarea"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                          maxHeight: '150px' 
                        }}
                        value={formData.myTeamRemarks}
                        onChange={(e) => setFormData({ ...formData, myTeamRemarks: e.target.value })}
                        placeholder="Enter team remarks"
                      />
                      {fieldError("myTeamRemarks")}
                    </div>
                    <div className="flex flex-col">
                      <p>Parent Team</p>
                      <input
                        type="text"
                        className="profile-input"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '200px'
                        }}
                        value={formData.masterTeamCode}
                        onChange={(e) => setFormData({ ...formData, masterTeamCode: e.target.value })}
                        placeholder="Enter parent team code"
                      />
                      {fieldError("masterTeamCode")}
                    </div>
                    <div className="flex flex-col">
                        <label>
                        <input className='mr-4' type="checkbox" checked={formData.isLevel} onChange={(e) => setFormData({ ...formData, isLevel: e.target.checked })} />
                        Team Has Hierarchy?
                        </label>
                    </div>
                </div>
                
                <div className="border rounded-lg p-4 shadow-md bg-lime-400 mt-2">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center">
                    <button className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}</button>
                    <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate(-1)}>Cancel</button>
                    {/* {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>} */}
                  </div>
                </div>
              </div>
            )}
          </div>
      </MainLayout>
    </>
  )
}

export default MyTeamCreate